export const LANGUAGES_MAX_COUNT = 5
